<template>
  <v-container class="px-0 mx-0">
    <v-layout justify-end>
      <v-btn @click="exportExcel" width="150" :loading="loading" class="  light--text text-capitalize btn_fnt" color="primary"> <v-icon small class="me-2">mdi-export</v-icon>Export </v-btn>
    </v-layout>
    <div v-show="false">
      <v-data-table id="exportContactMethod" hide-default-footer :items-per-page="-1" :headers="headers" :items="contactMethodList" class="elevation-1 "> </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { Utils } from "../../utils/utils";
export default {
  props: {
    contactMethodList: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      variables: {
        limit: 0,
        skip: 0,
      },
      headers: [
        { text: "Method En", value: "method", width: 230 },
        { text: "Method Ar", value: "methodAr", width: 230 },
      ],
    };
  },
  created() {
    //    this.head=this.headers.filter(x=>x.value!='actions' && x.value!='index')
  },

  methods: {
    exportExcel() {
      this.loading = true;
      Utils.htmlToExcel("exportContactMethod", "Contact Method", false);

      this.loading = false;
    },
  },
};
</script>
